// extracted by mini-css-extract-plugin
module.exports = {"label":"conflictForm_label__3bPh6","wrapper":"conflictForm_wrapper__2bjvx","error":"conflictForm_error__2T01P","addConflictBtn":"conflictForm_addConflictBtn__1ONRZ"};